export const FETCH_DASHBOARD_BINS = 'FETCH_DASHBOARD_BINS';
export const FETCH_DASHBOARD_BINS_SUCCESS = 'FETCH_DASHBOARD_BINS_SUCCESS';
export const FETCH_DASHBOARD_BINS_FAIL = 'FETCH_DASHBOARD_BINS_FAIL';

export const FETCH_TOTAL_PENDING_ALERTS = 'FETCH_TOTAL_PENDING_ALERTS';
export const FETCH_TOTAL_PENDING_ALERTS_SUCCESS =
  'FETCH_TOTAL_PENDING_ALERTS_SUCCESS';
export const FETCH_TOTAL_PENDING_ALERTS_FAIL =
  'FETCH_TOTAL_PENDING_ALERTS_FAIL';

export const FETCH_CASE_AGING_STATS = 'FETCH_CASE_AGING_STATS';
export const FETCH_CASE_AGING_STATS_SUCCESS = 'FETCH_CASE_AGING_STATS_SUCCESS';
export const FETCH_CASE_AGING_STATS_FAIL = 'FETCH_CASE_AGING_STATS_FAIL';
export const UPDATE_DASHBOARD_FILTERS = 'UPDATE_DASHBOARD_FILTERS';

export const fetchDashboardBins = () => ({
  type: FETCH_DASHBOARD_BINS
});

export const fetchDashboardBinsSuccess = (dashboardBins) => ({
  type: FETCH_DASHBOARD_BINS_SUCCESS,
  payload: dashboardBins
});

export const fetchDashboardBinsFail = () => ({
  type: FETCH_DASHBOARD_BINS_FAIL
});

export const fetchTotalPendingAlerts = (filters) => ({
  type: FETCH_TOTAL_PENDING_ALERTS,
  payload: filters
});

export const fetchTotalPendingAlertsSuccess = (total) => ({
  type: FETCH_TOTAL_PENDING_ALERTS_SUCCESS,
  payload: total
});

export const fetchTotalPendingAlertsFail = () => ({
  type: FETCH_TOTAL_PENDING_ALERTS_FAIL
});

export const fetchCaseAgingStats = ({ filters, caseAgingBins }) => {
  return {
    type: FETCH_CASE_AGING_STATS,
    payload: { filters, caseAgingBins }
  };
};

export const fetchCaseAgingStatsSuccess = ({
  total,
  ages,
  automationCases,
  manualCases,
  otherCases
}) => ({
  type: FETCH_CASE_AGING_STATS_SUCCESS,
  payload: { total, ages, automationCases, manualCases, otherCases }
});

export const fetchCaseAgingStatsFail = () => ({
  type: FETCH_CASE_AGING_STATS_FAIL
});

export const updateDashboardFilters = (filters) => ({
  type: UPDATE_DASHBOARD_FILTERS,
  payload: filters
});
